<template>
    <div>
        <div class="table-area" v-if="groups_ids && filteredStudents">
                <table class="competition-results__table">
                    <thead>
                      <tr>
                        <th class="white--text" v-for="(header, index) in headers" :key="index">{{header.text}}</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(student, index) in filteredStudents" :key="index">
                            <td> {{student.surname}} </td>
                            <td> {{student.name}} </td>
                            <td v-for="(competition, index2) in student.competitions" :key="index2" :class="[competition.attempts == '' ? 'empty-cell' : '']">                            
                                <span class="competition-result-card cursor-pointer" v-for="(attempt, index3) in competition.attempts" :key="index3" @click="showCompetition(student.user_id, competition.competition_id, attempt.attempt_id)">
                                    <div class="competition-result-card__score">{{attempt.score}}/{{attempt.max_score}}</div> <div class="competition-result-card__datetime" v-html="getNicerDateFormat(attempt.begin_at)"></div>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
        <v-card-text v-if="filteredStudents" class="text-align-right">
            count: {{filteredStudents.length}}
        </v-card-text>
    </div>
</template>

<script>
 import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            group_id: 0,
            headers: null,
            filteredStudents: null,
            students : null,
            chapters : null,
            igroups: null,
            typeRes: 0
        }
    },
    mounted() {
       this.initData()
    },   
    props: ['groups_ids','course_id'],
        watch: {
            groups_ids() {
                this.refreshData()
                return this.groups_ids
            }
    },
    methods : {
        initData() {
            let _data = {
                course_id: this.course_id
            }
            axios.post('/get-teaching-groups-competitions', _data, this.$store.getters.getAxiosConfig )
                .then(res => {
                    /* eslint-disable no-console */
                    // console.log(res.data)
                    this.competitions = res.data.competitions   
                    this.students = res.data.students
                    this.refreshData()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        refreshData() {
            this.headers = []
            this.headers.push( {text: "surname", value : "surname"})
            this.headers.push( {text: "name", value : "name"})
            for(let i = 0; i < this.competitions.length; i++) {
                this.headers.push( {
                    text: this.competitions[i].name.substring(0,25),
                    value: 'c' + this.competitions[i].competition_id,
                    competition_id: this.competitions[i].competition_id
                })
            }
            this.filteredStudents = []
            for(let i = 0; i < this.students.length; i++) {
                if (this.groups_ids.indexOf(this.students[i].group_id) > -1)  {
                    const competitions = []
                    for(let j = 0; j < this.competitions.length; j++) {
                        const attempts = []
                        for(let k = 0; k < this.students[i].competitions.length; k++) {
                            if (this.competitions[j].competition_id == this.students[i].competitions[k].id) {
                                // add atempts
                                for(let l = 0; l < this.students[i].competitions[k].attempts.length; l++) {
                                    attempts.push({
                                        attempt_id: this.students[i].competitions[k].attempts[l].attempt_id,
                                        begin_at: this.students[i].competitions[k].attempts[l].begin_at,
                                        score: this.students[i].competitions[k].attempts[l].score,
                                        max_score: this.students[i].competitions[k].attempts[l].max_score
                                    })
                                }
                            }
                        }
                        competitions.push({
                            competition_id: this.competitions[j].competition_id,
                            attempts: attempts
                        })
                    }
                    this.filteredStudents.push({
                        user_id: this.students[i].user_id,
                        name: this.students[i].name,
                        surname: this.students[i].surname,
                        group_id: this.students[i].group_id,
                        competitions: competitions
                    })
                }
            }
            //console.log(this.filteredStudents)            
        },
        showCompetition(user_id, competition_id, attempt_id) {
            // console.log(user_id + ',' + competition_id + ',' + attempt_id)
            this.$router.push({name:'show_competition', params: {id: attempt_id}}) 
        },
        getNicerDateFormat(date) {
            if (date == '') return "N/A"
            const dateVar = new Date(date.replace(/\s/, 'T'));
            return (dateVar.getDate()+". "+("0"+(dateVar.getMonth()+1)).slice(-2)+". "+dateVar.getFullYear()+"<br/>"+dateVar.getHours()+":"+("0"+(dateVar.getMinutes())).slice(-2))+":"+("0"+(dateVar.getSeconds())).slice(-2); 
        }
    }
}
</script>